var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BoostTypes from '../action-types/boost';
import { getSocketIfExist } from '../utils/getSocket';
import { sendAccessBoostWords } from '../utils/ws-v1';
export const addBoostWordsRequest = () => ({
    type: BoostTypes.ADD_BOOST_WORDS_REQUEST,
});
export const addBoostWords = (words, callbacks) => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(addBoostWordsRequest());
        const ws = getSocketIfExist();
        if (ws) {
            if (callbacks && callbacks.onSuccess)
                callbacks.onSuccess();
            sendAccessBoostWords(ws, 'add', words.join(','));
        }
        else {
            if (callbacks && callbacks.onFailure)
                callbacks.onFailure();
        }
    });
};
export const setAddBoostWordsSuccess = (value) => ({
    type: BoostTypes.SET_ADD_BOOST_WORDS_SUCCESS,
    payload: value,
});
export const setAddBoostWordsLoading = (value) => ({
    type: BoostTypes.SET_ADD_BOOST_WORDS_LOADING,
    payload: value,
});
export const deleteBoostWordRequest = () => ({
    type: BoostTypes.DELETE_BOOST_WORD_REQUEST,
});
export const deleteBoostWord = (word) => {
    return (dispatch, getState) => __awaiter(void 0, void 0, void 0, function* () {
        dispatch(deleteBoostWordRequest());
        const ws = getSocketIfExist();
        if (ws) {
            sendAccessBoostWords(ws, 'remove', word);
        }
    });
};
export const setBoostWords = (words) => ({
    type: BoostTypes.SET_BOOST_WORDS,
    payload: words,
});
